import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { APPLICATION_INITIATED_QUERY, BASEURL_POLYMER } from '../../utils/api'
import { ApplicationInitiated } from '../../models/polymer/ApplicationInitiated.model'
interface QueryParams {
  hdb_ref: string
  singpass_token: string,
  uinfin: string
}
export const applicationHasInitiatedApi = createApi({
  reducerPath: 'applicationHasInitiatedApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASEURL_POLYMER,
    prepareHeaders: (headers, { getState }) => {
      headers.set("Access-Control-Request-Method", "POST");
      headers.set("X-Content-Type-Options", "nosniff");
    }
  }),
  endpoints: (builder) => ({
    getCheckApplicationHasInitiatedByHdbRef: builder.query<ApplicationInitiated, QueryParams>({
      query: (queryParams: QueryParams) => (
        {
          method: "POST",
          url: `${APPLICATION_INITIATED_QUERY}?hdbRef=${queryParams.hdb_ref}`,
          headers: {
            Authorization: `Bearer ${queryParams.singpass_token}`,
            uinfin: queryParams.uinfin
          },
        }),
      keepUnusedDataFor: 1,
    }),

  }),
})

export const { useGetCheckApplicationHasInitiatedByHdbRefQuery } = applicationHasInitiatedApi
